import React from "react";
import PageBanner from "../../../components/sections/front/Common/PageBanner";
import BannerImage from "../../../assets/image/image-page-banner.webp";
import OurPartners from "../../../components/sections/front/Common/OurPartners";
import SectionProjects from "../../../components/sections/front/Projects/SectionProjects";
import { useBanner } from "../../../providers/BannerProviders";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
const Projects = () => {
  const { data } = useBanner();
  const projectBanner = data?.data?.find(
    (item) => item?.bannerType === "projects"
  );
  const location = useLocation();
  const projectData = location.state?.projectData;

  return (
    <>
      {projectBanner && (
        <Helmet>
          <title>{projectBanner.seoTitle}</title>
          <meta
            name="description"
            property="og:description"
            content={projectBanner.seoDescription}
          />
          <meta
            name="keywords"
            property="og:keywords"
            content={projectBanner.seoKeyword}
          />
          <meta
            name="author"
            property="og:author"
            content={projectBanner.seoAuthor}
          />
          <meta
            property="og:image"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
          <meta
            property="og:image:secure_url"
            content="https://api.vpeters.iosx.in/storage/siteSetting/1744792455206fdfb9210eeb9358cf800c535.jpeg"
          />
        </Helmet>
      )}
      <PageBanner
        title={projectBanner?.title}
        image={projectBanner?.image?.url}
      />
      <SectionProjects projectData={projectData} />
      <OurPartners />
    </>
  );
};

export default Projects;
